module.exports = __webpack_public_path__ + "static/basic-4eb44cef2e483322a30a66f3430d5c26.svg";